namespace JupitersChoice {
    export class ShowFreeGameSummaryCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('CurrencyFormatter') _currencyFormatter: Sapphire.CurrencyFormatter;
        @inject('EventManager') _eventManager: Sapphire.EventManager;
        @inject('GameServer') _server: Sapphire.GameServer;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('SoundManager') _soundManager: Sapphire.SoundManager;
        @inject('TranslationsManager') _translationsManager: Sapphire.TranslationsManager;

        execute(): void {
            const response: any = this._server.logicResponse;
            const totalWonAmount = this._componentManager.get('FreeGameSummaryTotalWonAmount');
            const cycler = this._componentManager.get('Cycler');
            let totalWinFromBaseAndFreeGame  = response.win;

            // free game total won = response.win - any base game wins
            if (response.winnings.length > 0) {
                response.winnings.forEach(winning => {
                    totalWinFromBaseAndFreeGame -= winning[2];
                });
            }

            // Kill pay cycling
            cycler.kill();
            this._eventManager.publish('onHideSkipPaylinesButton');

            var duration: number = this._soundManager.musicMuted ? 3 : 10;

            this._soundManager.fadeTo('free_spin_music_loop',0,1000);

            TweenMax.delayedCall(1, () => {
                this._layerManager.setVisibility('Modals', true);
                this._componentManager.get('FreeGamePopup').show();

                var formattedText = '';
                
                if(totalWinFromBaseAndFreeGame > 0){
                    formattedText = this._translationsManager.get('framework.youwon').replace('{0}',
                        this._currencyFormatter.format(totalWinFromBaseAndFreeGame));
                }else{
                    formattedText = this._translationsManager.get('framework.freespins_nowin');
                }

                totalWonAmount.setText(formattedText);
                totalWonAmount.show();

                TweenMax.delayedCall(duration, () => {
                    this._componentManager.get('WipeFlare').play(
                        () => {
                            this._layerManager.setVisibility('FreeGame', false);
                            this._layerManager.setVisibility('Modals', false);
                            this._componentManager.get('FreeGamePopup').hide();
                            totalWonAmount.hide()
                            totalWonAmount.setText('');
                            this._eventManager.publish('onShowFreeGameSummaryComplete');
                        }
                    );
                });

                
                this._soundManager.play('free_spin_summary');
            });
        }
    }
}